import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../Contexts/AuthProvider';
import { SettingIcon } from '../../../../utils/SVGIcon';
import { GetDate } from '../../../../utils/Show';
import { mkRelativeUrl } from '../../../../utils/URL';
import cn from '../../../../utils/cn';

function ManageButton({ onclick }) {
    return (
        <button
            type="button"
            onClick={onclick}
            className="bg-[#FDF1E0] text-warning w-[31px] p-[7px] rounded-[7px]"
        >
            <SettingIcon />
        </button>
    );
}

function TableInfoCard({ name, value, isCapitalize, className }) {
    return (
        <div
            className={cn(
                'text-sm text-primary-700 font-medium flex flex-row gap-3 justify-start items-center h-auto',
                className
            )}
        >
            <p className="inline-flex justify-between items-center min-w-[112px] w-32">
                <span>{name}</span>
                <span>:</span>
            </p>
            <span
                className={cn(`value-text line-clamp-1 text-primary font-normal text-sm`, {
                    capitalize: isCapitalize
                })}
            >
                {value}
            </span>
        </div>
    );
}

function TableRow({ item }) {
    const [isActive, setIsActive] = useState(false);

    const { authInfo } = useAuth();

    const navigate = useNavigate();

    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsActive(!isActive)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-80': isActive,
                    'max-h-10': !isActive,
                    'placeholder-mode': item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div className="min-w-[112px] w-28">
                    <span>{item?.id}</span>
                </div>
                <div className="w-full">
                    <span className="line-clamp-1">{item?.applicationTitle}</span>
                </div>
                <div className="w-full hidden sm:block">
                    <span
                        className={`line-clamp-1 capitalize ${
                            item?.status === 'active' ? 'text-success' : 'text-warning'
                        }`}
                    >
                        {item?.status}
                    </span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard name="Short Description" value={item?.description} />

                <TableInfoCard
                    name="Created Date"
                    value={GetDate(item?.timeCreated)}
                    isCapitalize
                />

                <TableInfoCard name="Last Update" value={GetDate(item?.timeUpdated)} isCapitalize />

                <TableInfoCard
                    name="Status"
                    value={item?.status}
                    isCapitalize
                    className={`sm:hidden ${item?.status === 'active' ? '[&>.value-text]:text-success' : '[&>.value-text]:text-warning'}`}
                />

                <div className="flex flex-row gap-px justify-end items-center">
                    <ManageButton
                        onclick={() =>
                            navigate(mkRelativeUrl(`/settings/products/${item.id}/info`))
                        }
                        disabled={authInfo?.data?.id === item?.id}
                    />
                </div>
            </div>
        </div>
    );
}

function ServiceListBodyMobile({ data }) {
    return (
        <div className="customer_page_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50">
                {data && data?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Data Found</div>
                ) : (
                    data?.map((item) => <TableRow key={item.id} item={item} />)
                )}
            </div>
        </div>
    );
}

export default ServiceListBodyMobile;
